import React, { useEffect } from 'react';
import AOS from 'aos'
import 'aos/dist/aos.css'

import HTML from '../assets/html.png';
import CSS from '../assets/css.png';
import JavaScript from '../assets/javascript.png';
import ReactImg from '../assets/react.png';
import Redux from '../assets/redux.png';
import Node from '../assets/node.png';
import Next from '../assets/next.png';
import GitHub from '../assets/github.png';
import Tailwind from '../assets/tailwind.png';
import Mongo from '../assets/mongo.png';
import Bootstrap from '../assets/bootstrap.jpeg';
import Express from '../assets/express.png';
import Postgre from '../assets/postgresql.png';
import Supabase from '../assets/supabase.png';
import Linux from '../assets/linux.png';

const Skills = () => {
    useEffect(() => {
        AOS.init({ duration: 2500 });
    }, []);
    return (
        <div className='w-full h-[screen] bg-[#0a192f] text-gray-300'>
            {/* Container */}
            <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
                <div name='skills' className='mt-[6rem] md:mt-[8rem]'>
                    <div data-aos='fade' className='mt-[5rem] md:mt-[7rem]'>
                        <p className='text-4xl font-bold inline border-b-4 border-pink-600'>Skills</p>
                        <p className='py-4'>These are the technologies I've worked with</p>
                    </div>

                    <div data-aos='fade' className='w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8'>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 mx-auto' src={HTML} alt="HTML icon" />
                            <p className='my-4'>HTML</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 mx-auto' src={CSS} alt="HTML icon" />
                            <p className='my-4'>CSS</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 mx-auto' src={JavaScript} alt="HTML icon" />
                            <p className='my-4'>JAVASCRIPT</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 h-20 mx-auto rounded-full' src={Bootstrap} alt="HTML icon" />
                            <p className='my-4'>BOOTSTRAP</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 mx-auto' src={Tailwind} alt="HTML icon" />
                            <p className='my-4'>TAILWIND</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 mx-auto' src={ReactImg} alt="HTML icon" />
                            <p className='my-4'>REACT JS</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 mx-auto rounded-full border-white border-8' src={Redux} alt="HTML icon" />
                            <p className='my-4'>REDUX</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 mx-auto' src={ReactImg} alt="HTML icon" />
                            <p className='my-4'>REACT NATIVE</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 mx-auto rounded-full' src={Next} alt="HTML icon" />
                            <p className='my-4'>NEXT JS</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 mx-auto' src={Node} alt="HTML icon" />
                            <p className='my-4'>NODE JS</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 h-20 mx-auto rounded-full' src={Express} alt="HTML icon" />
                            <p className='my-4'>EXPRESS JS</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 h-20 mx-auto rounded-full' src={Postgre} alt="HTML icon" />
                            <p className='my-4'>POSTGRE SQL</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 mx-auto' src={Mongo} alt="HTML icon" />
                            <p className='my-4'>MONGO DB</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 h-20 mx-auto rounded-full' src={Supabase} alt="HTML icon" />
                            <p className='my-4'>SUPABASE</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 mx-auto' src={GitHub} alt="HTML icon" />
                            <p className='my-4'>GITHUB</p>
                        </div>
                        <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                            <img className='w-20 h-20 mx-auto rounded-full' src={Linux} alt="HTML icon" />
                            <p className='my-4'>LINUX</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skills;
